import { IconType } from "react-icons";
import { RxDashboard } from "react-icons/rx";
import { MdOutlineAddAlert } from "react-icons/md";
import { FaSearchPlus } from "react-icons/fa";
import { FaUsersBetweenLines } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { PiStudentFill } from "react-icons/pi";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { LiaQuestionSolid } from "react-icons/lia";
import { GrResources } from "react-icons/gr";
import { BsCassette } from "react-icons/bs";
import { MdAppRegistration } from "react-icons/md";
import { MdOutlineEmergencyRecording } from "react-icons/md";
import { BiSolidContact } from "react-icons/bi";

type NavItemTypeWithoutChild = {
  label: string;
  moduleName: string;
  path: string;
  icon: IconType;
  children?: never;
  badge?: any;
};

type NavItemTypeWithChild = {
  label: string;
  moduleName: string;
  path?: never;
  badge?: any;
  icon: IconType;
  children?: {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const navigation: NavItemType[] = [
  {
    label: "Dashboard",
    icon: RxDashboard,
    moduleName: UserModuleNameTypes.DASHBOARD,
    path: "/dashboard",
  },
  {
    label: "Pending-Followup",
    icon: MdOutlineAddAlert,
    moduleName: UserModuleNameTypes.PENDING_FOLLOWUP,
    path: "/pending-followups",
  },
  {
    label: "Inquiries",
    icon: FaSearchPlus,
    moduleName: UserModuleNameTypes.INQUIRIES,
    path: "/inquiries",
  },
  {
    label: "Contact",
    icon: BiSolidContact,
    moduleName: UserModuleNameTypes.INQUIRIES,
    path: "/contact",
  },
  {
    label: "Batches",
    icon: FaUsersBetweenLines,
    moduleName: UserModuleNameTypes.BATCHES,
    path: "/batches",
  },

  {
    label: "Trainer",
    icon: GrUserManager,
    moduleName: UserModuleNameTypes.TRAINER,
    path: "/trainer",
  },
  {
    label: "Student",
    icon: PiStudentFill,
    moduleName: UserModuleNameTypes.STUDENT,
    path: "/student",
  },
  {
    label: "Team Resources",
    moduleName: UserModuleNameTypes.RESOURCE,
    icon: MdAppRegistration,
    path: "/team-resources",
  },
  {
    label: "Resources",
    moduleName: UserModuleNameTypes.RESOURCE,
    icon: GrResources,
    path: "/resources",
  },
  {
    label: "Assets",
    moduleName: UserModuleNameTypes.ASSETS,
    icon: BsCassette,
    path: "/asset",
  },

  {
    label: "Question Bank",
    moduleName: UserModuleNameTypes.QUESTION,
    icon: LiaQuestionSolid,
    path: "/question-bank",
  },

  {
    label: "Recording Request",
    moduleName: UserModuleNameTypes.QUESTION,
    icon: MdOutlineEmergencyRecording,
    path: "/recording-request",
  },
  {
    label: "Recording Rules",
    moduleName: UserModuleNameTypes.QUESTION,
    icon: MdOutlineEmergencyRecording,
    path: "/recording-rules",
  },
];
